import { makeObservable, observable, flow, action } from "mobx";
import { toast } from "sonner";

import { api } from "@/lib/services";
import { ApiRoutes } from "@/lib/routes";
import AssignAuditRegistrySchema from "@/areas/settings/schemas/AssignAuditRegistrySchema";

export default class AssignAuditRegistryStore {
  visible = false;
  processing = false;

  constructor(parentStore) {
    makeObservable(this, {
      visible: observable,
      processing: observable,
      show: action,
      hide: action,
      toggle: action,
      save: flow,
    });

    this.parentStore = parentStore;
  }

  get canAssign() {
    const isAdmin = this.parentStore.parentStore.parentStore?.authenticationStore?.isAdmin;

    return (
      isAdmin ||
      this.parentStore.registryPermissionStore.isCoordinator ||
      this.parentStore.registryPermissionStore.isInheritedCoordinator ||
      this.parentStore.registryPermissionStore.isInheritedResponsible
    );
  }

  show() {
    this.visible = true;
  }

  hide() {
    this.visible = false;
  }

  toggle(visible) {
    this.visible = visible === true ? true : visible === false ? false : !this.visible;
  }

  *save(data, options) {
    try {
      this.processing = true;

      const parseResult = AssignAuditRegistrySchema.safeParse(data);
      if (!parseResult.success) {
        return parseResult;
      }

      const response = yield api.post(ApiRoutes.forAuditAssign(data.id), data);
      this.visible = false;
      toast.success("Registry assigned successfully");
      this.parentStore.load({ id: data.id });
      return { success: true, data: response.data };
    } catch (e) {
      toast.error("Error while assigning control", {
        description: e?.response?.data?.message || "Unexpected error, please try again later.",
      });
      return { success: false, error: e };
    } finally {
      this.processing = false;
    }
  }
}
